import { useQuery } from '@tanstack/react-query';
import { Link, useSearchParams } from 'react-router';
import { formatDatum } from '../lib/formaz.ts';
import { supabase } from '../lib/supabase.ts';
import { ALLAPOT_CIMKE, allapotE, FULEK, szuresAllapotra } from '../super/regisztracioLista.ts';
import { Betolto, Fokonyv, HibaUzenet, OldalFej, Ures } from '../ui/elemek.tsx';

export default function SuperRegisztraciok() {
  const [params, setParams] = useSearchParams();
  const kert = params.get('allapot');
  const aktiv = allapotE(kert) ? kert : FULEK[0]!;

  const lista = useQuery({
    queryKey: ['super-regisztraciok'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('iroda_regisztraciok')
        .select('id, allapot, iroda_nev, cegnev, iroda_telepules, kapcsolattarto_nev, kapcsolattarto_email, created_at')
        .order('created_at', { ascending: false });
      if (error) throw error;
      return data;
    },
  });

  const sorok = szuresAllapotra(lista.data ?? [], aktiv);
  const darab = (a: (typeof FULEK)[number]) => szuresAllapotra(lista.data ?? [], a).length;

  return (
    <div className="grid gap-4">
      <OldalFej cim="Regisztrációk" leiras="Az irodák online regisztrációi. Hozzáférés csak a jóváhagyás után keletkezik." />
      <div role="group" aria-label="Állapot szerinti szűrés" className="flex flex-wrap gap-2">
        {FULEK.map((a) => (
          <button
            key={a} type="button" aria-pressed={a === aktiv}
            onClick={() => setParams(a === FULEK[0] ? {} : { allapot: a }, { replace: true })}
            className={`min-h-10 rounded-xl border px-3.5 text-sm transition ${a === aktiv ? 'border-kiemelt bg-kiemelt-halvany text-kiemelt' : 'border-vonal text-szoveg-halk hover:bg-felulet hover:text-szoveg'}`}
          >
            {ALLAPOT_CIMKE[a]}{lista.data && <span className="szam ml-1.5">{darab(a)}</span>}
          </button>
        ))}
      </div>
      <HibaUzenet hiba={lista.error} />
      {lista.isPending && <Betolto />}
      {lista.data && sorok.length === 0 && <Ures cim="Nincs regisztráció" szoveg={`Nincs „${ALLAPOT_CIMKE[aktiv]}” állapotú regisztráció.`} />}
      {sorok.length > 0 && (
        <Fokonyv>
          <ul className="divide-y divide-vonal">
            {sorok.map((r) => (
              <li key={r.id}>
                <Link to={`/super/regisztraciok/${r.id}`} className="flex min-h-14 flex-wrap items-center justify-between gap-x-4 gap-y-1 px-5 py-3.5 hover:bg-felulet">
                  <span className="grid min-w-0">
                    <span className="truncate font-semibold">{r.iroda_nev}</span>
                    <span className="truncate text-sm text-szoveg-halk">{r.cegnev}, {r.iroda_telepules}</span>
                    <span className="truncate text-sm text-szoveg-halk">{r.kapcsolattarto_nev} ({r.kapcsolattarto_email})</span>
                  </span>
                  <span className="flex items-center gap-3 text-sm text-szoveg-halk">
                    <span>{formatDatum(r.created_at)}</span>
                    <span className="sr-only">{ALLAPOT_CIMKE[aktiv]}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </Fokonyv>
      )}
    </div>
  );
}
